import * as React from 'react';
/**
 *
 * Original name: home
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A386
 *
 */
export const HomePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M55.223 25.417 32 7.473 8.777 25.417l2.445 3.165L14 26.436V53h13V39a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14h13V26.436l2.777 2.146 2.446-3.165ZM46 49h-5V39a6.007 6.007 0 0 0-6-6h-6a6.007 6.007 0 0 0-6 6v10h-5V23.346l14-10.819 14 10.819V49Z", fill: "currentColor" })));
